import { AnimatePresence } from 'framer-motion';
import { Navigate, Route, Routes } from 'react-router-dom';
import FullLayout from 'src/components/Layout/FullLayout/FullLayout';
import { AuthPlaceholder } from 'src/containers/App/AuthPlaceholder';
import { HelpPage } from 'src/containers/Help/Help';
import { RedirectApp } from 'src/containers/RedirectApp/RedirectApp';
import { usePrescriberContext } from 'src/providers/PrescriberProvider';
import { ProtectedRoute } from './ProtectedRoute';
import {
  assistantProtectedRoutes,
  commomReturnableProtectedRoutes,
  doctorProtectedRoutes,
  doctorReturnableProtectedRoutes,
  errorRoutes,
  publicRoutes,
  redirectRoutes,
  onboardingRoutes,
} from './routes/routes';

function RootRouter() {
  const { isUserOnApp } = usePrescriberContext();

  return (
    <AnimatePresence mode="wait">
      <Routes>
        <Route path={'app/auth'} element={<AuthPlaceholder />} />
        <Route path={'app/redirect'} element={<RedirectApp />} />
        {!isUserOnApp &&
          publicRoutes.map((route) => {
            const Component = route.component;
            return <Route index={route.index} path={route.path} element={<Component />} key={route.path} />;
          })}
        <Route path={'/inicio'} element={<FullLayout />}>
          {redirectRoutes.map((route) => {
            return <Route path={route.path} element={<Navigate to={route.redirectTo} replace />} key={route.path} />;
          })}
          {doctorProtectedRoutes.map((route) => {
            const Component = route.component;
            return (
              <Route
                path={route.path}
                element={
                  <ProtectedRoute>
                    <Component />
                  </ProtectedRoute>
                }
                key={route.path}
              />
            );
          })}
        </Route>
        <Route path={'/inicio'} element={<FullLayout showGoBack />}>
          {doctorReturnableProtectedRoutes.map((route) => {
            const Component = route.component;
            return (
              <Route
                path={route.path}
                element={
                  <ProtectedRoute>
                    <Component />
                  </ProtectedRoute>
                }
                key={route.path}
              />
            );
          })}
        </Route>
        <Route path={'/assistente'} element={<FullLayout />}>
          {assistantProtectedRoutes.map((route) => {
            const Component = route.component;
            return (
              <Route
                path={route.path}
                element={
                  <ProtectedRoute>
                    <Component />
                  </ProtectedRoute>
                }
                key={route.path}
              />
            );
          })}
        </Route>
        <Route path={'/inicio'} element={<FullLayout showGoBack />}>
          {commomReturnableProtectedRoutes.map((route) => {
            const Component = route.component;
            return (
              <Route
                path={route.path}
                element={
                  <ProtectedRoute>
                    <Component />
                  </ProtectedRoute>
                }
                key={route.path}
              />
            );
          })}
        </Route>
        {onboardingRoutes.map((route) => {
          const Component = route.component;
          return (
            <Route
              path={route.path}
              element={
                <ProtectedRoute>
                  <Component />
                </ProtectedRoute>
              }
              key={route.path}
            />
          );
        })}
        {errorRoutes.map((route) => {
          const Component = route.component;
          return <Route path={route.path} element={<Component />} key={route.path} />;
        })}
        <Route path={'/ajuda'} element={<HelpPage />} />
      </Routes>
    </AnimatePresence>
  );
}

export default RootRouter;
